import Copyright from "03AdminPages/99Parts/Copyright";
import { Box, Container, CssBaseline, styled, Typography } from "@mui/material";
const MyPaper = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(8),
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

const LastUpdate = styled("p")(() => ({
  textAlign: "end",
}));
const TitleText = styled("h1")(({ theme }) => ({
  marginTop: theme.spacing(8),
  textAlign: "center",
}));

const Paragraph = styled("li")(() => ({
  margin: "24px",
}));

const Paragraph2 = styled("li")(() => ({
  margin: "24px",
  listStyleType: "none",
  listStylePosition: "inside",
  counterIncrement: "cnt",
  "&::before": {
    content: `"(" counter(cnt) ") "`,
  },
}));

const EulaPage = () => {
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <LastUpdate>最終更新日 2025年4月1日</LastUpdate>
      <TitleText>利用規約</TitleText>
      <MyPaper>
        <p>
          この利用規約（以下、「本規約」といいます。）は、旭光電機株式会社（以下、「当社」といいます。）が漏水みはり番（以下、「本製品」）を使ってこのウェブサイト上で提供する漏水みはり番監視システム向けサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って、本サービスをご利用いただきます。
        </p>
        <Typography variant="h6">第１条（適用）</Typography>
        <ol>
          <Paragraph>
            本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
          </Paragraph>
          <Paragraph>
            当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
          </Paragraph>
          <Paragraph>
            本規約の規定が個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り、個別規定の規定が優先されるものとします。
          </Paragraph>
        </ol>
        <Typography variant="h6">第２条（本サービス利用契約の成立）</Typography>
        <ol>
          <Paragraph>
            本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、当社と登録希望者の間に、本規約を内容とする本サービスの利用契約が成立したものとみなします。
          </Paragraph>
          <Paragraph>
            当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
          </Paragraph>

          <ol>
            <Paragraph>
              利用登録の申請に際して虚偽の事項を届け出た場合
            </Paragraph>
            <Paragraph>
              本規約に違反したことがある者からの申請である場合
            </Paragraph>
            <Paragraph>
              その他、当社が利用登録を相当でないと判断した場合
            </Paragraph>
          </ol>
        </ol>
        <Typography variant="h6">
          第３条（ユーザーＩＤおよびパスワードの管理）
        </Typography>
        <ol>
          <Paragraph>
            ユーザーは、自己の責任において、本サービスのユーザーＩＤおよびパスワードを適切に管理するものとします。
          </Paragraph>
          <Paragraph>
            ユーザーは、いかなる場合にも、ユーザーＩＤおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーＩＤとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーＩＤを登録しているユーザー自身による利用とみなします。
          </Paragraph>
          <Paragraph>
            ユーザーＩＤおよびパスワードが第三者によって使用されたことによって生じた損害は、当社に故意又は重大な過失がある場合を除き、当社は一切の責任を負わないものとします。
          </Paragraph>
        </ol>
        <Typography variant="h6">第４条（利用料金および支払方法）</Typography>
        <ol>
          <Paragraph>
            本サービスの対価及び支払方法は、ユーザーと販売代理店との契約、もしくは、ユーザーと当社との契約により定めるものとします。
          </Paragraph>
          <Paragraph>
            本製品は、本サービスに登録してから、3年間、通信が可能です。
          </Paragraph>
          <Paragraph>
            本サービスに登録した本製品の通信履歴は、登録から4年間、閲覧可能です。
          </Paragraph>
        </ol>
        <Typography variant="h6">第５条（権利帰属）</Typography>
        <ol>
          <Paragraph>
            本製品、本サービス等に関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約の成立に基づく本サービス等の利用許諾は、本規約に基づく本サービスの利用の限度で、それら知的財産権の使用を許諾するものです。
          </Paragraph>
          <Paragraph>
            お客様は、いかなる理由によっても当社または当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません）をしないものとします。
          </Paragraph>
        </ol>
        <Typography variant="h6">第６条（秘密保持）</Typography>
        <ol>
          <Paragraph>
            本規約において「秘密情報」とは、本製品または本サービス等に関連して、当社およびお客様が、相手方より書面、口頭または記録媒体等により提供もしくは開示されたか、または知得した、相手方の技術、営業、業務、財務、組織、その他の事項に関する全ての情報を意味します。
          </Paragraph>
          <Paragraph>
            前項の定めにかかわらず、次の各号のいずれかに該当する情報は、前項における秘密情報から除くものとします。
          </Paragraph>
          <ol>
            <Paragraph2>
              提供もしくは開示がなされたときまたは知得したときに、既に一般に公知となっていた、または既に知得していたもの
            </Paragraph2>
            <Paragraph2>
              提供もしくは開示がなされた後または知得した後、自己の責めに帰すべき事由によらず、刊行物その他により公知となったもの
            </Paragraph2>
            <Paragraph2>
              提供または開示の権限のある第三者から秘密保持義務を負わされることなく適法に取得したもの
            </Paragraph2>
            <Paragraph2>秘密情報によることなく単独で開発したもの</Paragraph2>
            <Paragraph2>
              秘密保持の必要なき旨、相手方から書面で確認したもの
            </Paragraph2>
          </ol>
          <Paragraph>
            当社およびお客様は、秘密情報を本製品または本サービス等の利用の目的のみに利用するとともに、相手方の書面による承諾なしに第三者に相手方の秘密情報を提供、開示または漏洩しないものとします。
          </Paragraph>
          <Paragraph>
            前項の定めに拘わらず、当社およびお客様は、法令、裁判所または行政機関の判決、決定、命令その他要請（以下併せて「要請等」といいます）に基づき、秘密情報を開示することができます。ただし、要請等があった場合、速やかにその旨を相手方に通知しなければなりません。
          </Paragraph>
          <Paragraph>
            当社およびお客様は、秘密情報を記載した文書または磁気記録媒体等を複製する場合には、事前に相手方の書面による承諾を得ることとし、複製物の管理については第２項に準じて厳重に行うものとします。
          </Paragraph>
          <Paragraph>
            当社およびお客様は、相手方から求められた場合にはいつでも、遅滞なく、相手方の指示に従い、秘密情報ならびに秘密情報を記載または包含した書面その他の記録媒体物およびその全ての複製物を返却または廃棄しなければなりません。
          </Paragraph>
          <Paragraph>
            当社とお客様の間で別途秘密保持に関する契約・協定等を締結するときは、別途協議するものとします。
          </Paragraph>
        </ol>
        <Typography variant="h6">第７条（禁止事項）</Typography>
        <p>
          ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
        </p>
        <ol>
          <Paragraph>法令または公序良俗に違反する行為</Paragraph>
          <Paragraph>犯罪行為に関連する行為</Paragraph>
          <Paragraph>
            本サービスの内容等、本サービスに含まれる著作権、商標権ほか知的財産権を侵害する行為
          </Paragraph>
          <Paragraph>
            当社、ほかのユーザー、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
          </Paragraph>
          <Paragraph>
            本サービスによって得られた情報を商業的に利用する行為
          </Paragraph>
          <Paragraph>当社のサービスの運営を妨害するおそれのある行為</Paragraph>
          <Paragraph>不正アクセスをし、またはこれを試みる行為</Paragraph>
          <Paragraph>
            他のユーザーに関する個人情報等を収集または蓄積する行為
          </Paragraph>
          <Paragraph>不正な目的を持って本サービスを利用する行為</Paragraph>
          <Paragraph>
            本サービスの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為
          </Paragraph>
          <Paragraph>他のユーザーに成りすます行為</Paragraph>
          <Paragraph>
            当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
          </Paragraph>
          <Paragraph>その他、当社が不適切と判断する行為</Paragraph>
        </ol>
        <Typography variant="h6">第８条（本サービスの提供の停止等）</Typography>
        <ol>
          <Paragraph>
            当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
          </Paragraph>
          <ol>
            <Paragraph>
              本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
            </Paragraph>
            <Paragraph>
              地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
            </Paragraph>
            <Paragraph>
              コンピュータまたは通信回線等が事故その他の理由により停止した場合
            </Paragraph>
            <Paragraph>
              その他、当社が本サービスの提供が困難と判断した場合
            </Paragraph>
          </ol>
          <Paragraph>
            当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
          </Paragraph>
        </ol>

        <Typography variant="h6">第９条（利用制限および登録抹消）</Typography>
        <ol>
          <Paragraph>
            当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
          </Paragraph>
          <ol>
            <Paragraph>本規約のいずれかの条項に違反した場合</Paragraph>
            <Paragraph>登録事項に虚偽の事実があることが判明した場合</Paragraph>
            <Paragraph>料金等の支払債務の不履行があった場合</Paragraph>
            <Paragraph>当社からの連絡に対し、一定期間返答がない場合</Paragraph>
            <Paragraph>
              本サービスについて、最終の利用から一定期間利用がない場合
            </Paragraph>
            <Paragraph>
              その他、当社が本サービスの利用を適当でないと判断した場合
            </Paragraph>
          </ol>
          <Paragraph>
            当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
          </Paragraph>
        </ol>

        <Typography variant="h6">第１０条（退会）</Typography>
        <p>
          ユーザーは、当社の定める退会手続により、本サービスから退会できるものとします。
        </p>

        <Typography variant="h6">
          第１１条（本製品の性能及び免責事項）
        </Typography>
        <ol>
          <Paragraph>
            本製品は、当社が規定した特定の状況下における漏水を検知する機能を有するものであり、あらゆる状況下での漏水を検知するものではありません。液体の性状、温度、作動環境等の諸原因により、漏水の検知ができない場合があります。
          </Paragraph>
          <Paragraph>
            当社は、本サービスに起因してユーザーに生じたあらゆる損害について、当社の故意又は重過失による場合を除き、一切の責任を負わず、賠償される損害の範囲は、６万６０００円を上限とします。但し、法令に別段の定めがある場合、その限度において、この限りではありません。
          </Paragraph>
          <Paragraph>
            前項にかかわらず、消費者契約法が適用される取引関係においては、当社は、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害、間接損害、逸失利益及び拡大損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負わず、賠償される損害の範囲は、6万６０００円を上限とします。
          </Paragraph>
          <Paragraph>
            ユーザーから当社に対する損害賠償請求は、ユーザーが損害の発生及び当該損害が本製品に起因することを知った日から3ヶ月を経過する日までに請求をしなかったときは、ユーザーは、その権利を失うものとします。
          </Paragraph>
          <Paragraph>
            当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
          </Paragraph>
          <Paragraph>
            前各項の規定にかかわらず、通信キャリア・クラウド提供事業者の帰責事由による本サービスの利用不能の場合には、当社は、当社の過失を前提として、通信キャリア・クラウド提供業者から受領した損害賠償額を限度としてユーザーに生じた損害(但し、現実に発生した通常損害に限られ、特別損害、間接損害、逸失利益、拡大損害は含みません。)についてのみ責任を負います。
          </Paragraph>
          <Paragraph>
            電気通信設備又はシステムの修理、復旧等に当たって、その電気通信設備又はシステムに記憶されている内容等が変化又は消失することがあります。当社はかかる変化又は消失につき責任を負いません。
          </Paragraph>
        </ol>

        <Typography variant="h6">第１２条（サービス内容の変更等）</Typography>
        <p>
          当社は、ユーザーへの事前の告知をもって、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。
        </p>

        <Typography variant="h6">第１３条（利用規約の変更）</Typography>
        <ol>
          <Paragraph>
            当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。
          </Paragraph>
          <ol>
            <Paragraph>
              本規約の変更がユーザーの一般の利益に適合するとき。
            </Paragraph>
            <Paragraph>
              本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
            </Paragraph>
          </ol>
          <Paragraph>
            当社はユーザーに対し、前項による本規約の変更にあたり、事前に、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を通知します。
          </Paragraph>
        </ol>

        <Typography variant="h6">第１４条（個人情報の取扱い）</Typography>
        <p>
          当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。
        </p>

        <Typography variant="h6">第１５条（通知または連絡）</Typography>
        <p>
          ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
        </p>

        <Typography variant="h6">第１６条（権利義務の譲渡の禁止）</Typography>
        <p>
          ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
        </p>

        <Typography variant="h6">第１７条（準拠法・裁判管轄）</Typography>
        <ol>
          <Paragraph>
            本規約の解釈にあたっては、日本法を準拠法とします。
          </Paragraph>
          <Paragraph>
            本サービスに関して紛争が生じた場合には、大阪地方裁判所をもって第一審の専属合意管轄裁判所とします。
          </Paragraph>
        </ol>
      </MyPaper>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default EulaPage;
